var _defs, _rect, _rect2, _rect3, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmartsen2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "barGrad",
    x1: "0%",
    y1: "100%",
    x2: "0%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#22C55E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#3B82F6"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 66,
    width: 14,
    height: 36,
    rx: 3,
    fill: "url(#barGrad)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 52,
    width: 14,
    height: 50,
    rx: 3,
    fill: "url(#barGrad)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 40,
    width: 14,
    height: 62,
    rx: 3,
    fill: "url(#barGrad)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 48 L58 30 L82 34",
    fill: "none",
    stroke: "#FACC15",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M82 34 L76 30 L78 38 Z",
    fill: "#FACC15"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartsen2);
export default __webpack_public_path__ + "static/media/smartsen_2.1b46ff18553dbc78206f69df5fb12262.svg";
export { ForwardRef as ReactComponent };